"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TenantList = exports.tenantListDescription = exports.CreateTenantPayload = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const Tenant = __importStar(require("../../../../../../tenant"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Admin.Tenant.Schema';
/**
 * Body of `POST /v2/admin/tenant/:tenantId`, where the path segment is the parent
 * tenant id the new tenant is attached to (the router spells it `:parentTenantId`).
 * `omit` drops `id`, `createdAt` and `updatedAt` only on this tenant. `subTenants`
 * stays required, and each nested tenant keeps those fields.
 */
exports.CreateTenantPayload = Tenant.Tenant.pipe(effect_1.Schema.omit('id', 'createdAt', 'updatedAt')).annotations({
    identifier: `${exports.NAMESPACE}.CreateTenantPayload`,
    description: 'Fields for the tenant being created. id, createdAt and updatedAt are omitted only here and assigned by the server. subTenants is required, and each nested tenant still has its own id, createdAt and updatedAt, which the server stores as sent.',
});
exports.tenantListDescription = "The root tenant's direct children. Root is not included. Deeper tenants appear only nested under subTenants.";
/** `data` of `GET /v2/admin/tenant`. */
exports.TenantList = effect_1.Schema.Struct({
    items: effect_1.Schema.Array(Tenant.Tenant),
}).annotations({
    identifier: `${exports.NAMESPACE}.TenantList`,
    description: exports.tenantListDescription,
});
//# sourceMappingURL=schema.js.map